/**
业务单据反算工具类
ver 1.0.0
修改记录：
  2019-11-20
    orderBackCountUtil.
*/
import calculateUtils from '../calculateUtil'
import objectUtil from '../objectUtil'
let orderBackCountUtil = {}

/**
 * 参与计算对应字段
 * @数量 {[amount]}
 * @报价 {[pricing]}
 * @折扣率 {[discount]}
 * @含税单价 {[price]}
 * @无税单价 {[netPrice]}
 * @无税金额 {[netMoney]}
 * @税额 {[netTax]}
 * @计量单位{[unitDisplay]}
 * @折扣额 {[discountTotal]}
 * @价税合计 {[priceTotal]}
 * @税率  {[rate]}
 * @是否赠品  {[attrs.valueText.discount]}
 * @含税报价总金额  {[pricingTotal]}
 * @采购含税单价  {[purchaseItem.price]}
 * @采购含税金额  {[purchaseItem.priceTotal]}
 *
 *   (页面暂无此字段)pricingTotal = 精确到分(amount * pricing)
 *
 * @折扣金额总计  {[discountsTotal]}
 * @折让金额  {[discountsDiffTotal]}
 * @促销折扣相关（促销折扣、促销折扣率、促销折扣额）  {[saleDownDiscount]}
 * @招标折扣相关（招标折扣、招标折扣率、招标折扣额）  {[publicDiscount]}
 * @销售折扣相关（销售折扣、销售折扣率、销售折扣额）  {[saleDiscount]}
 * @其他折扣1相关（其他折扣1、其他折扣率1、其他折扣额1）  {[otherDiscount1]}
 * @其他折扣1相关（其他折扣2、其他折扣率2、其他折扣额2）  {[otherDiscount2]}
 * @其他折扣1相关（其他折扣3、其他折扣率3、其他折扣额3）  {[otherDiscount3]}
 *  六个折扣相关的结构为下面所示    {
    	  discount: 2.21, // 折扣（单个）
      	discount: 2.21, // 折扣（单个）
      	discountTotal: 22.1, // 折扣额
      	discountTotal: 22.1, // 折扣额
      	discountRate: 0.1, // 折扣率
      	discountRate: 0.1 // 折扣率
       }
 */

/**
 * [刷新价格时计算]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 数量不变
  含税单价=报价-折扣1到6之和
  原有修改含税单价反算
  分别算 折扣率1到6=[1-(折扣1到6÷报价)]*100%
  分别算 折扣额1到6=折扣1到6*数量
  折扣金额总计=折扣额合
 */
orderBackCountUtil.refreshPrice = function (data, formData, decimal = 6) {
  orderBackCountUtil.initDiscounts(data)
  data.price = calculateUtils.numberSub(data.pricing, orderBackCountUtil.discountsFn(data), decimal)
  orderBackCountUtil.price(data, formData, decimal)
  // data.discounts[fildKey].discountRate = calculateUtils.numberSub(1,calculateUtils.numberDiv(data.discounts[fildKey].discount,data.pricing,decimal),decimal)
  // data.discounts[fildKey].discountTotal = calculateUtils.numberMul(data.discounts[fildKey].discount,data.amount,2)
  orderBackCountUtil.discountTotalFn(data)

  //将数据添加到items后再计算折扣金额合计
  // if(!formData.order) formData.order = {}
  // formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData,data)
  // formData.order.discountsDiffTotal = 0
}

/**
 * [录入、修改报价]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 含税单价＝报价×扣率
  价税合计＝含税单价×数量
  无税金额＝价税合计÷（1＋税率）
  税额＝价税合计－无税金额
  无税单价＝无税金额÷数量
  折扣额＝报价×数量－价税合计
 */
orderBackCountUtil.pricing = function (data, formData, decimal = 6) {
  if (data.pricing == 0 || !data.pricing) {
    data.discount = 1 //扣率
    // data.discountTotal = 0;//折扣额
  }

  data.price = calculateUtils.numberMul(data.pricing, data.discount, decimal) //含税单价
  data.priceTotal = calculateUtils.numberMul(data.price, data.amount, 2) //价税合计
  data.netMoney = calculateUtils.numberDiv(
    data.priceTotal,
    calculateUtils.numberAdd(1, data.rate, decimal),
    2
  ) //无税金额
  data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2) //税额
  data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal) //无税单价
  data.discountTotal = calculateUtils.numberSub(
    calculateUtils.numberMul(data.pricing, data.amount, decimal),
    data.priceTotal,
    2
  ) //折扣额

  data.pricingTotal = calculateUtils.numberMul(data.amount, data.pricing, decimal) //含税报价总金额
}

/**
 * [录入、修改含税单价]
 * @param  {[type]} data    [行数据data]
    * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则数量、税率、报价、扣率2不变，依次计算：
  价税合计＝含税单价×数量
  无税金额＝价税合计÷（1＋税率）
  税额＝价税合计－无税金额
  无税单价＝无税金额÷数量
  报价不等于零情况下，扣率=含税单价/报价、折扣额＝报价×数量－价税合计。
  报价等于零情况下，扣率=100，折扣额=0.
 */
orderBackCountUtil.price = function (data, formData, decimal = 6) {
  data.priceTotal = calculateUtils.numberMul(data.price, data.amount, 2) //价税合计
  data.netMoney = calculateUtils.numberDiv(
    data.priceTotal,
    calculateUtils.numberAdd(1, data.rate, decimal),
    2
  ) //无税金额
  data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2) //税额
  data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal) //无税单价
  if (data.pricing == 0 || !data.pricing) {
    data.discount = 1 //扣率
    data.discountTotal = 0 //折扣额
  } else {
    data.discount = calculateUtils.numberDiv(data.price, data.pricing, decimal) //扣率
    data.discountTotal = calculateUtils.numberSub(
      calculateUtils.numberMul(data.pricing, data.amount, decimal),
      data.priceTotal,
      2
    ) //折扣额
  }
}
/**
 * [录入、修改销售含税单价]
 * @param  {[type]} data    [行数据data]
    * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则数量、税率、报价、扣率2不变，依次计算：
  销售含税金额＝含税单价×数量
  销售无税金额＝价税合计÷（1＋税率）
  销项税额＝价税合计－无税金额
 */
orderBackCountUtil['attrs.valueDecimal.salePrice'] = function (data, formData, decimal = 6) {
  //销售含税金额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleTotal',
    calculateUtils.numberMul(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.salePrice'),
      data.amount,
      2
    )
  )
  //销售无税金额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleNetMoney',
    calculateUtils.numberDiv(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
      calculateUtils.numberAdd(
        1,
        objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleRate'),
        decimal
      ),
      2
    )
  )
  //销项税额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleTax',
    calculateUtils.numberSub(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleNetMoney'),
      2
    )
  )
}
/**
 * [录入、修改价税合计]
 * @param  {[type]} data    [行数据data]
   * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 录入、修改价税合计，则数量、税率、报价不变，依次计算：
   无税金额＝价税合计÷（1＋税率）
   税额＝价税合计－无税金额
   含税单价＝价税合计÷数量
   无税单价＝无税金额÷数量
   报价不等于零情况下，如果"报价含税"，扣率＝价税合计/（报价×数量）、计算折扣额＝报价×数量－价税合计（报价为零时，扣率置为100，且扣率不允许修改，折扣额为零）；如果"报价不含税"，则扣率＝无税金额/（报价×数量）、折扣额＝报价×数量×（1＋税率）－价税合计。
 */
orderBackCountUtil.priceTotal = function (data, formData, decimal = 6) {
  data.netMoney = calculateUtils.numberDiv(
    data.priceTotal,
    calculateUtils.numberAdd(1, data.rate, decimal),
    2
  ) //无税金额
  data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2) //税额
  data.price = calculateUtils.numberDiv(data.priceTotal, data.amount, decimal) //含税单价
  data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal) //无税单价
  if (data.pricing == 0 || !data.pricing) {
    data.discount = 1 //扣率
    data.discountTotal = 0 //折扣额
  } else {
    data.discount = calculateUtils.numberDiv(
      data.priceTotal,
      calculateUtils.numberMul(data.pricing, data.amount, decimal),
      decimal
    ) //扣率
    data.discountTotal = calculateUtils.numberSub(
      calculateUtils.numberMul(data.pricing, data.amount, decimal),
      data.priceTotal,
      2
    ) //折扣额
  }
}

/**
 * [录入、修改采购含税单价]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 采购含税金额＝采购含税单价*数量
 */
orderBackCountUtil['purchaseItem.price'] = function (data) {
  if (!data.purchaseItem) data.purchaseItem = {}
  data.purchaseItem.priceTotal = calculateUtils.numberMul(data.purchaseItem.price, data.amount, 2) //价税合计
}

/**
 * [录入、修改采购含税金额]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 采购含税单价＝采购含税金额÷数量
 */
orderBackCountUtil['purchaseItem.priceTotal'] = function (data, formData, decimal = 6) {
  if (!data.purchaseItem) data.purchaseItem = {}
  data.purchaseItem.price = calculateUtils.numberDiv(
    data.purchaseItem.priceTotal,
    data.amount,
    decimal
  )
}

/**
 * [录入、修改税率]
 * @param  {[type]} data    [行数据data]
  * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则数量、价税合计、含税单价、报价不变，依次计算:
  税额＝价税合计/(1＋税率)*税率
  无税金额＝价税合计-税额
  如果税率！=0，无税单价＝无税金额÷数量；如果税率=0，无税单价=含税单价。(20180117修改)
  扣率=含税单价（前端显示值）/报价
  折扣额＝报价×数量－价税合计（允许为负数）=报价×数量－含税单价×数量，
  当报价为零时， 扣率置为100，且扣率不允许修改，折扣额为零

 */
orderBackCountUtil.rate = function (data, formData, decimal = 6) {
  data.netTax = calculateUtils.numberMul(
    calculateUtils.numberDiv(
      data.priceTotal,
      calculateUtils.numberAdd(1, data.rate, decimal),
      decimal
    ),
    data.rate,
    2
  ) //税额
  data.netMoney = calculateUtils.numberSub(data.priceTotal, data.netTax, 2) //无税金额
  if (data.rate == 0) {
    data.netPrice = data.price //无税单价
  } else {
    data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal) //无税单价
  }
  if (data.pricing == 0 || !data.pricing) {
    data.discount = 1 //扣率
    data.discountTotal = 0 //折扣额
  } else {
    data.discount = calculateUtils.numberDiv(data.price, data.pricing, decimal) //扣率
    data.discountTotal = calculateUtils.numberSub(
      calculateUtils.numberMul(data.pricing, data.amount, decimal),
      data.priceTotal,
      2
    ) //折扣额
  }
}
/**
 * [录入、修改 销项税率]
 * @param  {[type]} data    [行数据data]
  * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则数量、价税合计、含税单价、报价不变，依次计算:
  销项税额＝价税合计/(1＋税率)*税率
  销售无税金额＝价税合计-税额


 */
orderBackCountUtil['attrs.valueDecimal.saleRate'] = function (data, formData, decimal = 6) {
  //销项税额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleTax',
    calculateUtils.numberMul(
      calculateUtils.numberDiv(
        objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
        calculateUtils.numberAdd(
          1,
          objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleRate'),
          decimal
        ),
        decimal
      ),
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleRate'),
      2
    )
  )
  //销售无税金额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleNetMoney',
    calculateUtils.numberSub(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTax'),
      2
    )
  ) //无税金额
}

/**
     * [修改是否赠品]
     * @param  {[type]} data    [行数据data]
     * @param  {[type]} formData    [整单数据]
     * 若是赠品，折扣率为0%，若不是赠品，折扣率为100%

      */
orderBackCountUtil['attrs.valueText.discount'] = function (data, formData) {
  if (objectUtil.getValueByPath(data, 'attrs.valueText.discount', '') == 'gift') {
    orderBackCountUtil.initDiscounts(data)
    data.discounts.saleDownDiscount.discount = data.pricing
    orderBackCountUtil.discount(data, formData, 'saleDownDiscount')
    data.discounts.publicDiscount.discount = 0
    orderBackCountUtil.discount(data, formData, 'publicDiscount')
    data.discounts.saleDiscount.discount = 0
    orderBackCountUtil.discount(data, formData, 'saleDiscount')
    data.discounts.otherDiscount1.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount1')
    data.discounts.otherDiscount2.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount2')
    data.discounts.otherDiscount3.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount3')
    // data.discount=0
  } else {
    orderBackCountUtil.initDiscounts(data)
    data.discounts.saleDownDiscount.discount = 0
    orderBackCountUtil.discount(data, formData, 'saleDownDiscount')
    data.discounts.publicDiscount.discount = 0
    orderBackCountUtil.discount(data, formData, 'publicDiscount')
    data.discounts.saleDiscount.discount = 0
    orderBackCountUtil.discount(data, formData, 'saleDiscount')
    data.discounts.otherDiscount1.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount1')
    data.discounts.otherDiscount2.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount2')
    data.discounts.otherDiscount3.discount = 0
    orderBackCountUtil.discount(data, formData, 'otherDiscount3')
    // data.discount=1
  }
  // orderBackCountUtil.discount(data)
}

/**
 * [录入、修改计量单位]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 计量单位 : 计价单位 = divisor:dividend = 计量数量(amountDisplay) : 基本数量(amount)
 * 默认比例1:1
 */

orderBackCountUtil.unitDisplay = function (data, formData, decimal = 6) {
  if (data.unitDisplay && data.unitDisplay.ratio) {
    data.ratio = data.unitDisplay.ratio
  }
  if (!data.ratio)
    data.ratio = {
      divisor: 1,
      dividend: 1,
    }
  if (!data.ratio.divisor) data.ratio.divisor = 1
  if (!data.ratio.dividend) data.ratio.dividend = 1
  //计算待处理辅助单位数量
  data.planDisplay = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.plan, data.ratio.divisor, decimal),
    data.ratio.dividend,
    decimal
  )
  orderBackCountUtil.amountDisplay(data, formData, decimal)
}

/**
 * [录入、修改基本数量]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 计量单位 : 计价单位 = divisor:dividend = 计量数量(amountDisplay) : 基本数量(amount)
 * 默认比例1:1
 */

orderBackCountUtil.amountDisplay = function (data, formData, decimal = 6) {
  if (!data.ratio)
    data.ratio = {
      divisor: 1,
      dividend: 1,
    }
  if (!data.ratio.divisor) data.ratio.divisor = 1
  if (!data.ratio.dividend) data.ratio.dividend = 1

  data.amount = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amountDisplay, data.ratio.dividend, decimal),
    data.ratio.divisor,
    decimal
  )
  orderBackCountUtil.amount(data, formData, decimal)
}

/**
 * [根据数量反算辅助单位数量]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 计量单位 : 计价单位 = divisor:dividend = 计量数量(amountDisplay) : 基本数量(amount)
 * 默认比例1:1
 */
orderBackCountUtil.amountBack = function (data, formData, decimal = 6) {
  if (!data.ratio)
    data.ratio = {
      divisor: 1,
      dividend: 1,
    }
  if (!data.ratio.divisor) data.ratio.divisor = 1
  if (!data.ratio.dividend) data.ratio.dividend = 1

  data.amountDisplay = calculateUtils.numberDiv(
    calculateUtils.numberMul(data.amount, data.ratio.divisor, decimal),
    data.ratio.dividend,
    decimal
  )
  //在数量为0时设置为null
  data.amountDisplay = data.amount === null && data.amountDisplay === 0 ? null : data.amountDisplay
  orderBackCountUtil.amount(data, formData, decimal)
}

/**
 * [录入、修改数量]
 * @param  {[type]} data    [行数据data]
  * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则税率、含税单价、报价、扣率不变，并依次计算：
  价税合计＝含税单价×数量
  无税金额＝价税合计/(1＋税率)
  税额＝价税合计－无税金额
  无税单价＝无税金额/数量
  折扣额＝报价×数量－价税合计
  当报价为零时， 扣率置为100，且扣率不允许修改，折扣额为零
 */
orderBackCountUtil.amount = function (data, formData, decimal = 6) {
  data.priceTotal = calculateUtils.numberMul(data.price, data.amount, 2) //价税合计
  data.netMoney = calculateUtils.numberDiv(
    data.priceTotal,
    calculateUtils.numberAdd(1, data.rate, decimal),
    2
  ) //无税金额
  data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2) //税额
  data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal) //无税单价
  data.discountTotal = calculateUtils.numberSub(
    calculateUtils.numberMul(data.pricing, data.amount, decimal),
    data.priceTotal,
    2
  ) //折扣额
  if (data.pricing == 0 || !data.pricing) {
    data.discount = 1 //扣率
    data.discountTotal = 0 //折扣额
  }

  data.pricingTotal = calculateUtils.numberMul(data.amount, data.pricing, decimal) //含税报价总金额

  //销售含税金额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleTotal',
    calculateUtils.numberMul(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.salePrice'),
      data.amount,
      2
    )
  )
  //销售无税金额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleNetMoney',
    calculateUtils.numberDiv(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
      calculateUtils.numberAdd(
        1,
        objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleRate'),
        decimal
      ),
      2
    )
  )
  //销售税额
  objectUtil.setValueByPath(
    data,
    'attrs.valueDecimal.saleTax',
    calculateUtils.numberSub(
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleTotal'),
      objectUtil.getValueByPath(data, 'attrs.valueDecimal.saleNetMoney'),
      2
    )
  )

  //计算采购含税金额
  if ('purchaseItem' in data) {
    if (!data.purchaseItem) data.purchaseItem = {}
    data.purchaseItem.priceTotal = calculateUtils.numberMul(data.purchaseItem.price, data.amount, 2) //价税合计
  }

  //无源销售退货单计算无税成本单价
  if (((formData?.order || {}).biz || {}).code === 'SALE_720') {
    if (!data.attrs) {
      data.attrs = {}
    }
    if (!data.attrs.valueDouble) {
      data.attrs.valueDouble = {}
    }
    if (data.cost) {
      data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2) //成本含税金额
      data.netCostTotal = calculateUtils.numberDiv(
        data.costTotal,
        calculateUtils.numberAdd(
          1,
          ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
          decimal
        ),
        2
      ) //无税成本金额
      data.netCost = calculateUtils.numberDiv(data.netCostTotal, data.amount, decimal) //无税成本单价
    } else {
      // 含税单价 = 无税单价 * (税率 + 1)
      data.cost = calculateUtils.numberMul(
        data.netCost,
        calculateUtils.numberAdd(
          1,
          ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
          decimal
        ),
        2
      )
      data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2) //成本含税金额
      // 无税金额= 无税单价 * 数量
      data.netCostTotal = calculateUtils.numberMul(data.netCost, data.amount, 2)
    }
    data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberSub(
      data.costTotal,
      data.netCostTotal,
      2
    ) //成本税额
  } else {
    //计算库存成本
    data.netCostTotal = calculateUtils.numberMul(data.netCost, data.amount, 2) //无税成本总价
    data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2) //含税成本总价
  }
  //计算毛利额毛利率
  //毛利额=无税金额-（库存成本*数量）
  //毛利率=毛利额/无税金额
  //毛利额：netProfit
  //毛利率：netMargin
  //库存成本：netCost
  // 无税金额 :netMoney
  if (data.netCost > 0 || data.netCost === 0) {
    data.netProfit = calculateUtils.numberSub(
      data.netMoney,
      calculateUtils.numberMul(data.netCost, data.amount, decimal),
      2
    )
    data.netMargin = calculateUtils.numberDiv(data.netProfit, data.netMoney, 4)
  }

  //计算六组折扣
  /***
    *修改数量，扣率、折扣不变
    原有修改数量反算
    折扣额1到6=折扣1到6*数量
    折扣金额总计=折扣额合计
    折让金额=0
    */
  orderBackCountUtil.discountTotalFn(data)
  if (!formData) return
  if (!formData.order) formData.order = {}
  formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData, data)
  formData.order.discountsDiffTotal = 0
}

/**
 * [录入、修改成本含税单价] (目前仅在无源销退使用)
 * @param  {[type]} data    [行数据data]
    * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 
  成本含税金额＝成本含税单价×数量
  无税成本金额＝成本含税金额÷（1＋税率）
  成本税额＝价税合计成本含税金额－无税成本金额
  无税成本单价＝无税金额无税成本金额÷数量
 */
orderBackCountUtil.cost = function (data, formData, decimal = 6) {
  if (((formData.order || {}).biz || {}).code === 'SALE_720') {
    if (!data.attrs) {
      data.attrs = {}
    }
    if (!data.attrs.valueDouble) {
      data.attrs.valueDouble = {}
    }
    data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2) //成本含税金额
    data.netCostTotal = calculateUtils.numberDiv(
      data.costTotal,
      calculateUtils.numberAdd(
        1,
        ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
        decimal
      ),
      2
    ) //无税成本金额
    data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberSub(
      data.costTotal,
      data.netCostTotal,
      2
    ) //成本税额
    data.netCost = calculateUtils.numberDiv(data.netCostTotal, data.amount, decimal) //无税成本单价
  }
}

/**
 * [录入、修改成本含税金额] (目前仅在无源销退使用)
 * @param  {[type]} data    [行数据data]
   * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 
   无税成本金额＝成本含税金额÷（1＋成本税率）
   成本税额＝成本含税金额－无税成本金额
   成本含税单价＝成本含税金额÷数量
   无税成本单价＝无税成本金额÷数量
*/
orderBackCountUtil.costTotal = function (data, formData, decimal = 6) {
  if (((formData.order || {}).biz || {}).code === 'SALE_720') {
    if (!data.attrs) {
      data.attrs = {}
    }
    if (!data.attrs.valueDouble) {
      data.attrs.valueDouble = {}
    }
    data.netCostTotal = calculateUtils.numberDiv(
      data.costTotal,
      calculateUtils.numberAdd(
        1,
        ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
        decimal
      ),
      2
    ) //无税成本金额
    data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberSub(
      data.costTotal,
      data.netCostTotal,
      2
    ) //成本税额
    data.cost = calculateUtils.numberDiv(data.costTotal, data.amount, decimal) //成本含税单价
    data.netCost = calculateUtils.numberDiv(data.netCostTotal, data.amount, decimal) //无税成本单价
  }
}

/**
 * [录入、修改成本税率] (目前仅在无源销退使用)
 * @param  {[type]} data    [行数据data]
  * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 
  成本税额＝成本含税金额/(1＋成本税率)*成本税率
  无税成本金额＝成本含税金额-成本税额
  如果成本税率！=0，无税成本单价＝无税成本金额÷数量；如果成本税率=0，无税成本单价=成本含税单价。
 */
orderBackCountUtil['attrs.valueDouble.saleReturnCostRate'] = function (
  data,
  formData,
  decimal = 6
) {
  if (((formData.order || {}).biz || {}).code === 'SALE_720') {
    if (!data.attrs) {
      data.attrs = {}
    }
    if (!data.attrs.valueDouble) {
      data.attrs.valueDouble = {}
    }
    let saleReturnCostRate = ((data.attrs || {}).valueDouble || {}).saleReturnCostRate
    if (data.cost) {
      // 含税金额 = 含税单价 * 数量
      data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2)
      data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberMul(
        calculateUtils.numberDiv(
          data.costTotal,
          calculateUtils.numberAdd(1, saleReturnCostRate, decimal),
          decimal
        ),
        saleReturnCostRate,
        2
      ) //成本税额
      data.netCostTotal = calculateUtils.numberSub(
        data.costTotal,
        data.attrs.valueDouble.saleReturnCostNetTax,
        2
      ) //无税成本金额
      if (saleReturnCostRate == 0) {
        data.netCost = data.cost //无税成本单价
      } else {
        data.netCost = calculateUtils.numberDiv(data.netCostTotal, data.amount, decimal) //无税成本单价
      }
    } else {
      // 含税单价 = 无税单价 * (税率 + 1)
      data.cost = calculateUtils.numberMul(
        data.netCost,
        calculateUtils.numberAdd(
          1,
          ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
          decimal
        ),
        2
      )
      // 含税金额 = 含税单价 * 数量
      data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2)
      // 无税金额= 无税单价 * 数量
      data.netCostTotal = calculateUtils.numberMul(data.netCost, data.amount, 2)
      // 税额 = 含税金额 - 无税金额
      data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberSub(
        data.costTotal,
        data.netCostTotal,
        2
      )
    }
  }
}

/**
 * [录入、修改扣率（报价为零不允许修改）]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 若报价含税，则数量、税率、报价不变，依次计算：
  含税单价＝报价×扣率
  价税合计＝含税单价×数量
  无税金额＝价税合计÷（1＋税率）
  税额＝价税合计－无税金额
  无税单价＝无税金额÷数量
  折扣额＝报价×数量－价税合计
 */
// orderBackCountUtil.discount = function(data, formData, decimal = 6) {
//     data.price = calculateUtils.numberMul(data.pricing, data.discount, decimal); //含税单价
//     data.priceTotal = calculateUtils.numberMul(data.price, data.amount, 2); //价税合计
//     data.netMoney = calculateUtils.numberDiv(data.priceTotal, calculateUtils.numberAdd(1, data.rate, decimal), 2); //无税金额
//     data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2); //税额
//     data.netPrice = calculateUtils.numberDiv(data.netMoney, data.amount, decimal); //无税单价
//     data.discountTotal = calculateUtils.numberSub(calculateUtils.numberMul(data.pricing, data.amount, decimal), data.priceTotal, 2); //折扣额
// }

// * @促销折扣相关（促销折扣、促销折扣率、促销折扣额）  {[saleDownDiscount]}
//  * @招标折扣相关（招标折扣、招标折扣率、招标折扣额）  {[publicDiscount]}
//  * @销售折扣相关（销售折扣、销售折扣率、销售折扣额）  {[saleDiscount]}
//  * @其他折扣1相关（其他折扣1、其他折扣率1、其他折扣额1）  {[otherDiscount1]}
//  * @其他折扣1相关（其他折扣2、其他折扣率2、其他折扣额2）  {[otherDiscount2]}

/**
 * [录入、修改折扣1到6]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} hideTotal    [是否隐藏折扣额]
 * @param  {[type]} decimal [保留小数多少位]
 * 修改折扣1到6，数量不变
  含税单价=报价-折扣1到6之和
  原有修改含税单价反算
  折扣率1到6=[1-(折扣1到6÷报价)]*100%
  折扣额1到6=折扣1到6*数量
  折扣金额总计=折扣额合计
  折让金额=0
 */
orderBackCountUtil.discount = function (data, formData, fildKey, decimal = 6) {
  orderBackCountUtil.initDiscounts(data)
  data.price = calculateUtils.numberSub(data.pricing, orderBackCountUtil.discountsFn(data), decimal)
  orderBackCountUtil.price(data)
  data.discounts[fildKey].discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts[fildKey].discount, data.pricing, decimal),
    decimal
  )
  data.discounts[fildKey].discountTotal = calculateUtils.numberMul(
    data.discounts[fildKey].discount,
    data.amount,
    2
  )
  if (!formData.order) formData.order = {}
  formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData, data)
  formData.order.discountsDiffTotal = 0
}

/**
 * [录入、修改折扣率1到6]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} hideTotal    [是否隐藏折扣额]
 * @param  {[type]} decimal [保留小数多少位]
 * 修改折扣率1到6，数量不变
  折扣1到6=报价*（1-折扣率1到6）
  折扣额1到6=折扣1到6*数量=报价*（1-折扣率1到6）*数量
  含税单价=报价-折扣1到6之和 =报价-折扣额1到6之和÷数量
  原有修改含税单价反算
  折扣金额总计=折扣额合计
  折让金额=0
 */
orderBackCountUtil.discountRate = function (data, formData, fildKey, decimal = 6) {
  orderBackCountUtil.initDiscounts(data)
  data.discounts[fildKey].discount = calculateUtils.numberMul(
    data.pricing,
    calculateUtils.numberSub(1, data.discounts[fildKey].discountRate),
    decimal
  )
  data.discounts[fildKey].discountTotal = calculateUtils.numberMul(
    calculateUtils.numberMul(
      data.pricing,
      calculateUtils.numberSub(1, data.discounts[fildKey].discountRate)
    ),
    data.amount,
    2
  )
  data.price = calculateUtils.numberSub(data.pricing, orderBackCountUtil.discountsFn(data), decimal)
  orderBackCountUtil.price(data)
  if (!formData.order) formData.order = {}
  formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData, data)
  formData.order.discountsDiffTotal = 0
}

/**
 * [录入、修改折扣额1到6]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} decimal [保留小数多少位]
 * 修改折扣额1到6，数量不变
  折扣率1到6=【1-折扣额1到6 ÷ （报价*数量）】*100%
  折扣1到6=折扣额1到6 ÷ 数量
  含税单价=报价-折扣1到6之和
  原有修改含税单价反算
  折扣金额总计=折扣额合计
  折让金额=0
 */
orderBackCountUtil.discountTotal = function (data, formData, fildKey, decimal = 6) {
  orderBackCountUtil.initDiscounts(data)
  data.discounts[fildKey].discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(
      data.discounts[fildKey].discountTotal,
      calculateUtils.numberMul(data.pricing, data.amount, decimal),
      decimal
    ),
    decimal
  )
  data.discounts[fildKey].discount = calculateUtils.numberDiv(
    data.discounts[fildKey].discountTotal,
    data.amount,
    decimal
  )
  data.price = calculateUtils.numberSub(data.pricing, orderBackCountUtil.discountsFn(data), decimal)
  orderBackCountUtil.price(data)
  if (!formData.order) formData.order = {}
  formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData, data)
  formData.order.discountsDiffTotal = 0
}

/**
 * [删除行后计算折扣金额总计]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} decimal [保留小数多少位]
 * 修改折扣额1到6，数量不变
  折扣率1到6=【1-折扣额1到6 ÷ （报价*数量）】*100%
  折扣1到6=折扣额1到6 ÷ 数量
  含税单价=报价-折扣1到6之和
  原有修改含税单价反算
  折扣金额总计=折扣额合计
  折让金额=0
 */
orderBackCountUtil.orderDiscountsTotalFn = function (formData) {
  if (!formData.order) formData.order = {}
  formData.order.discountsTotal = orderBackCountUtil.discountsTotalFn(formData)
  formData.order.discountsDiffTotal = 0
}

/**
 * [录入、修改折扣金额合计（0<=折扣金额总计=<报价*数量的总计），数量不变]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fild    [分配到那个折扣字段]
 * @param  {[type]} val    [折扣金额合计修改后的值]
 * @param  {[type]} decimal [保留小数多少位]
 *折扣1到6、折扣额1到6置为0，折扣率置为100%
  第4条中配置的整单折扣分配的折扣额=报价*数量÷ “报价*数量”总计 * 折扣金额总计，对应折扣率=【1-折扣额÷（报价*数量）】*100%，对应折扣=折扣额÷数量
  折让金额=折扣金额总计 - 折扣额1到6总计
  含税单价=报价-折扣1到6之和
  原有修改含税单价反算
 */
orderBackCountUtil.orderDiscountsTotal = function (formData, fild, val, decimal = 6) {
  if (!formData.items) formData.items = []
  let tatol = 0
  for (let item of formData.items) {
    //计算报价*数量总计和初始折扣、折扣额、折扣率
    if (!item.discounts) item.discounts = {}
    if (!item.discounts.saleDownDiscount) item.discounts.saleDownDiscount = {}
    item.discounts.saleDownDiscount.discount = 0
    item.discounts.saleDownDiscount.discountTotal = 0
    item.discounts.saleDownDiscount.discountRate = 1

    if (!item.discounts.publicDiscount) item.discounts.publicDiscount = {}
    item.discounts.publicDiscount.discount = 0
    item.discounts.publicDiscount.discountTotal = 0
    item.discounts.publicDiscount.discountRate = 1

    if (!item.discounts.saleDiscount) item.discounts.saleDiscount = {}
    item.discounts.saleDiscount.discount = 0
    item.discounts.saleDiscount.discountTotal = 0
    item.discounts.saleDiscount.discountRate = 1

    if (!item.discounts.otherDiscount1) item.discounts.otherDiscount1 = {}
    item.discounts.otherDiscount1.discount = 0
    item.discounts.otherDiscount1.discountTotal = 0
    item.discounts.otherDiscount1.discountRate = 1

    if (!item.discounts.otherDiscount2) item.discounts.otherDiscount2 = {}
    item.discounts.otherDiscount2.discount = 0
    item.discounts.otherDiscount2.discountTotal = 0
    item.discounts.otherDiscount2.discountRate = 1

    if (!item.discounts.otherDiscount3) item.discounts.otherDiscount3 = {}
    item.discounts.otherDiscount3.discount = 0
    item.discounts.otherDiscount3.discountTotal = 0
    item.discounts.otherDiscount3.discountRate = 1

    tatol = calculateUtils.numberAdd(
      tatol,
      calculateUtils.numberMul(item.pricing, item.amount),
      decimal
    )
  }
  for (let itemOne of formData.items) {
    //计算对应折扣、折扣率、折扣额
    let tempTatol = calculateUtils.numberMul(itemOne.pricing, itemOne.amount, decimal)
    itemOne.discounts[fild].discountTotal = calculateUtils.numberMul(
      calculateUtils.numberDiv(tempTatol, tatol),
      val,
      2
    )

    itemOne.discounts[fild].discountRate = calculateUtils.numberSub(
      1,
      calculateUtils.numberDiv(itemOne.discounts[fild].discountTotal, tempTatol),
      decimal
    )

    itemOne.discounts[fild].discount = calculateUtils.numberDiv(
      itemOne.discounts[fild].discountTotal,
      itemOne.amount,
      decimal
    )
  }

  let tempDiscountTotal = 0
  for (let itemTwo of formData.items) {
    //计算折扣额1-6总计和含税单价
    tempDiscountTotal = calculateUtils.numberAdd(
      tempDiscountTotal,
      itemTwo.discounts[fild].discountTotal,
      2
    )

    itemTwo.price = calculateUtils.numberSub(
      itemTwo.pricing,
      itemTwo.discounts[fild].discount,
      decimal
    )
    orderBackCountUtil.price(itemTwo)
  }
  if (!formData.order) formData.order = {}
  formData.order.discountsDiffTotal = calculateUtils.numberSub(
    formData.order.discountsTotal,
    tempDiscountTotal,
    2
  )
}

/**
 * [录入、修改库存成本（及选择批号时）]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 *计算毛利额毛利率
 //毛利额=无税金额-（库存成本*数量）
 //毛利率=毛利额/无税金额
 //毛利额：netProfit
 //毛利率：netMargin
 //库存成本：netCost
 // 无税金额 :netMoney

  * [录入、修改无税单价] (目前仅在无源销退使用)
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 
 * 含税单价：cost		数量：amount		含税金额：costTotal		     税率：saleReturnCostRate
 * 无税单价：netCost				       无税金额：netCostTotal		税额：saleReturnCostNetTax
 * 
  含税单价  = 无税单价 * 税率 + 无税单价
  含税金额  = 含税单价 * 数量
  无税金额  = 无税单价 * 数量
     税额  = 含税金额 - 无税金额
 */
orderBackCountUtil.netCost = function (data, formData, decimal = 6) {
  if (((formData.order || {}).biz || {}).code === 'SALE_720') {
    if (!data.attrs) {
      data.attrs = {}
    }
    if (!data.attrs.valueDouble) {
      data.attrs.valueDouble = {}
    }
    // 含税单价 = 无税单价 * (税率 + 1)
    data.cost = calculateUtils.numberMul(
      data.netCost,
      calculateUtils.numberAdd(
        1,
        ((data.attrs || {}).valueDouble || {}).saleReturnCostRate,
        decimal
      ),
      2
    )
    // 含税金额 = 含税单价 * 数量
    data.costTotal = calculateUtils.numberMul(data.cost, data.amount, 2)
    // 无税金额= 无税单价 * 数量
    data.netCostTotal = calculateUtils.numberMul(data.netCost, data.amount, 2)
    // 税额 = 含税金额 - 无税金额
    data.attrs.valueDouble.saleReturnCostNetTax = calculateUtils.numberSub(
      data.costTotal,
      data.netCostTotal,
      2
    )
  } else if (data.netCost > 0 || data.netCost === 0) {
    data.netProfit = calculateUtils.numberSub(
      data.netMoney,
      calculateUtils.numberMul(data.netCost, data.amount, decimal),
      2
    )
    data.netMargin = calculateUtils.numberDiv(data.netProfit, data.netMoney, 4)
  }
}

//初始化六组折扣字段
orderBackCountUtil.initDiscounts = function (data) {
  let discountKey = 'discounts'
  if (!data[discountKey]) data[discountKey] = {}
  if (!data[discountKey].saleDownDiscount) data[discountKey].saleDownDiscount = {}

  if (!data[discountKey].publicDiscount) data[discountKey].publicDiscount = {}

  if (!data[discountKey].saleDiscount) data[discountKey].saleDiscount = {}

  if (!data[discountKey].otherDiscount1) data[discountKey].otherDiscount1 = {}

  if (!data[discountKey].otherDiscount2) data[discountKey].otherDiscount2 = {}

  if (!data[discountKey].otherDiscount3) data[discountKey].otherDiscount3 = {}
}

//计算折扣额（折扣额1到6=折扣1到6*数量）
orderBackCountUtil.discountTotalFn = function (data) {
  orderBackCountUtil.initDiscounts(data)
  data.discounts.saleDownDiscount.discountTotal = calculateUtils.numberMul(
    data.discounts.saleDownDiscount.discount,
    data.amount,
    2
  )
  data.discounts.publicDiscount.discountTotal = calculateUtils.numberMul(
    data.discounts.publicDiscount.discount,
    data.amount,
    2
  )
  data.discounts.saleDiscount.discountTotal = calculateUtils.numberMul(
    data.discounts.saleDiscount.discount,
    data.amount,
    2
  )
  data.discounts.otherDiscount1.discountTotal = calculateUtils.numberMul(
    data.discounts.otherDiscount1.discount,
    data.amount,
    2
  )
  data.discounts.otherDiscount2.discountTotal = calculateUtils.numberMul(
    data.discounts.otherDiscount2.discount,
    data.amount,
    2
  )
  data.discounts.otherDiscount3.discountTotal = calculateUtils.numberMul(
    data.discounts.otherDiscount3.discount,
    data.amount,
    2
  )
}

//计算折扣金额总计（折扣金额总计=折扣额合计）
orderBackCountUtil.discountsTotalFn = function (formData, data) {
  if (!formData.items) formData.items = []
  let temp = 0
  for (let item of formData.items) {
    let tempItem = item
    if (data && data._ID == tempItem._ID) tempItem = data
    orderBackCountUtil.initDiscounts(tempItem)
    let temp5 = orderBackCountUtil.discountTotalSumFn(tempItem)
    temp = calculateUtils.numberAdd(temp, temp5, 2)
  }
  return temp
}

//计算折扣额1-6之和
orderBackCountUtil.discountTotalSumFn = function (data) {
  let temp1 = calculateUtils.numberAdd(
    data.discounts.saleDownDiscount.discountTotal,
    data.discounts.publicDiscount.discountTotal,
    2
  )
  let temp2 = calculateUtils.numberAdd(temp1, data.discounts.saleDiscount.discountTotal, 2)
  let temp3 = calculateUtils.numberAdd(temp2, data.discounts.otherDiscount1.discountTotal, 2)
  let temp4 = calculateUtils.numberAdd(temp3, data.discounts.otherDiscount2.discountTotal, 2)
  let temp5 = calculateUtils.numberAdd(temp4, data.discounts.otherDiscount3.discountTotal, 2)
  return temp5
}

//计算折扣1-6之和
orderBackCountUtil.discountsFn = function (data, decimal = 6) {
  let discountKey = 'discounts'
  let temp1 = calculateUtils.numberAdd(
    data[discountKey].saleDownDiscount.discount,
    data[discountKey].publicDiscount.discount,
    decimal
  )
  let temp2 = calculateUtils.numberAdd(temp1, data[discountKey].saleDiscount.discount, decimal)
  let temp3 = calculateUtils.numberAdd(temp2, data[discountKey].otherDiscount1.discount, decimal)
  let temp4 = calculateUtils.numberAdd(temp3, data[discountKey].otherDiscount2.discount, decimal)
  let temp5 = calculateUtils.numberAdd(temp4, data[discountKey].otherDiscount3.discount, decimal)
  return temp5
}

//用于跟台结果登记反算还回数量  还回数量=商品待结算/还回数量-使用数量(商品待结算/还回数量是一个字段：orderItem.amount；使用数量：usedCount; 还回数量：returnCount)
orderBackCountUtil.usedCount = function (data, formData, decimal = 6) {
  if (!data.orderItem) data.orderItem = {}
  data.returnCount = calculateUtils.numberSub(data.orderItem.amount, data.usedCount, decimal)
}

/**
 * [计算毛利]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 毛利金额=无税金额 - 库存成本价（无税金额）*数量
毛利率=毛利金额/无税金额*100%（保留两位小数），无税金额=0时，毛利率=-100%
netProfit：毛利额
netMargin：毛利率
netMoney：无税金额
netCost：库存成本价
 */
orderBackCountUtil.netMarginFn = function (data, formData, decimal = 6) {
  data.netProfit = calculateUtils.numberSub(
    data.netMoney,
    calculateUtils.numberMul(data.netCost, data.amount, decimal),
    decimal
  )
  if (data.netMoney) {
    data.netMargin = calculateUtils.numberDiv(data.netProfit, data.netMoney, decimal)
  } else {
    data.netMargin = -1
  }
}

/**
 * [选择批号后的计算（仅用与仓库内部业务，如调拨）]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} decimal [保留小数多少位]
 * 含税金额=含税单价*数量
 * 无税金额=无税单价*数量
 * 税额=含税金额-无税金额
 * 价税合计=含税金额
 * 折扣率=1
 * 折扣额=0
 */
orderBackCountUtil.batchCount = function (data) {
  data.priceTotal = calculateUtils.numberMul(data.price, data.amount, 2) //价税合计
  data.netMoney = calculateUtils.numberMul(data.netPrice, data.amount, 2) //无税金额
  data.netTax = calculateUtils.numberSub(data.priceTotal, data.netMoney, 2) //税额
  data.discount = 1 //扣率
  data.discountTotal = 0 //折扣额
}

export default orderBackCountUtil
